<template>
		<module-tab name="待发货" enable-flex @mounted="searchHandle" @activated="$refs.table.update()">
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="订单编号">
					<c-input name="order_number"></c-input>
				</m-search-item>
				<m-search-item label="商品ID">
					<c-input name="product_id"></c-input>
				</m-search-item>
				<m-search-item label="商品标题">
					<c-input name="product_name"></c-input>
				</m-search-item>
				<m-search-item label="支付时间" colspan="2">
					<c-datetime start-name="pay_start_date" end-name="pay_end_date" range></c-datetime>
				</m-search-item>
			</m-search>
            <m-operate v-if="userInfo.operation_mode == 2">
                <c-button @click="batchDelivery()" color="main">批量发货</c-button>
                <c-button @click="$refs.excelImport.open()" icon="excel">导入发货</c-button>
            </m-operate>
			<c-table ref="table" height="grow">
				<c-table-column
					type="selector"
					name="selected"
				></c-table-column>

				<c-table-column
					width="360"
				>
					<template slot="head">
						<!-- <c-checkbox></c-checkbox> -->
						<span style="margin-left: 15px;">商品信息</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="单价"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="下单数"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="小计"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="已发货"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="已退款"
					width="130"
					align-center
				></c-table-column>
				
				<c-table-column
					label="待发货"
					width="130"
					align-center
				></c-table-column>
				
				<!-- <c-table-column
					label="交易状态"
					width="120"
					align-center
				></c-table-column> -->
				
				<c-table-column
					label="操作"
					width="130"
					align-center
                    v-if="userInfo.operation_mode == 2"
				></c-table-column>
				
				<template #custom="{data}">
					<div :key="data.id" class="order">
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<c-checkbox v-model="data.selected"></c-checkbox>
								<span class="number">订单号：{{data.order_number}}</span>
                                <p class="info" >支付时间：{{data.payment_date}}</p>
							</div>
						</div>
						<div class="order-head flex-between-center">
							<div class="flex-center">
								<p v-if="data.operation_mode == 2">收件信息：{{data.receiving_name}},{{data.receiving_phone}},{{data.receiving_address}}</p>
								<p class="info" v-if="data.operation_mode == 2">物流信息：{{data.logistics_company_name}}</p>
							</div>
						</div>
						<div class="flex">
							<div class="order-product">
								<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
									<div class="sku-info flex-center flex-grow">
										<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
										<div class="flex-grow">
                                            <p class="sku-name ellipsis">
                                                <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                                {{sku.product_name}}
                                            </p>
											<p class="sku-sku"><span style="color: darkgray">规格：</span>{{sku.product_sku_spec}}</p>
											<p class="sku-sku" v-if="sku.product_sku_code"><span style="color: darkgray">SKU编码：</span>{{sku.product_sku_code}}</p>
										</div>
									</div>
									<div class="sku-price">￥{{sku.product_unit_price}}</div>
									<div class="sku-count">{{sku.product_count}}</div>
									<div class="sku-price">￥{{sku.product_cost_money}}</div>
									<div class="sku-count">{{sku.send_count}}</div>
									<div class="sku-count">{{sku.total_refund_count}}</div>
									<div class="sku-delivery_count">{{sku.product_count - sku.send_count - sku.total_refund_count}}</div>
								</div>
							</div>
							<!-- <div class="order-state flex-column flex-center">
								<span>{{orderStateName[data.order_state]}}</span>
								<span v-if="data.order_state == 3">({{data.deliver_state}})</span>
								<a @click="navigateTo(`/order_wait_delivery_detail/${data.order_number}`)">订单详情</a>
							</div> -->
							<div class="order-handle flex-column flex-center" v-if="userInfo.operation_mode == 2">
								<c-button color="main" v-if="data.operation_mode == 2" @click="navigateTo(`/order_wait_delivery_detail/${data.order_number}`)">去发货</c-button>
							</div>
						</div>
					</div>
				</template>
			</c-table>

            <!--订单发货弹框（全部发货） -->
            <c-dialog ref="orderSendAll" title="批量发货" width="500" button-name="发货" @resolve="batchDeliveryHandle">
                <div style="background: #FAFAFA;">
                    <c-form ref="orderSendAllForm">
                        <c-form-item label="物流公司">
                            <c-select :value="lastLogisticsCompany" name="logistics_company_id" :options="logisticsCompany"></c-select>
                        </c-form-item>
                        <c-form-item label="运单号">
                            <c-input name="logistics_number"></c-input>
                        </c-form-item>
                    </c-form>
                </div>
            </c-dialog>
            <!--导入发货-->
            <excel-import ref="excelImport" :work-type="importWorkType" @resolve="$refs.table.update();"></excel-import>
		</module-tab>
</template>

<script>
	import {mapState} from "vuex";
    import excelImport from "@/components/service/import_excel_data.vue";

    export default {
        components: {excelImport},
		props: {
			tab: String
		},
        computed: {
            ...mapState(['userInfo']),
        },
        mounted() {
            this.initData();
        },
		data() {
			return {
                importWorkType: 901,//导入发货
				currentTab: {},
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				},
                deliveryOrderNumbers:[],
                lastLogisticsCompany: '',
                logisticsCompany: []
            }
		},
		
		methods: {
            initData(){
                //加载可用发货物流
                this.request({
                    url: '/standard_logistics/all',
                    data: {},
                    success: data => {
                        this.logisticsCompany = Array.from(data, item => {
                            return {
                                name: item.logistics_name,
                                value: item.id
                            };
                        });
                    }
                });
                //查找最后一次发货的物流公司
                this.request({
                    url: '/standard_logistics/last/delivery/company',
                    data: {},
                    success: data => {
                        this.lastLogisticsCompany = data;
                    }
                });
            },
			tabHandle(item, index) {
				if (index != this.tab) {
					this.navigateTo({
						query: {
							tab: index
						}
					})
				}
				
				this.currentTab = item;
				this.$refs.search.search();
			},

			searchHandle(data) {
				this.$refs.table.load({
					url: '/order/wait_delivery_detail_list',
					data: data
				});
			},

            openImportDialog() {
                this.$refs.deliverForm.clear();
                this.$refs.dialog.open();
            },

            //导入发货
            importDeliver(stop, next) {
                stop();
                this.$refs.deliverForm.submit({
                    url: '/order/importDeliver',
                    rule: {
                        filePath:'请上传导入文件'
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success:(data,res) => {
                        next();
                        this.$refs.search.search();
                        this.$confirm({
                            title: '执行结果',
                            message: res,  // 提示内容,
                            buttonName: '确定',  // 确定按钮文字
                            icon: 'success',
                            cancelButton: false  // 是否显示取消按钮
                        });
                    }
                });
            },
            /**批量发货*/
            batchDelivery() {
                this.deliveryOrderNumbers = [];
                var list = this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        message: '请选择需要发货的订单'
                    });
                    return;
                }
                this.deliveryOrderNumbers = Array.from(list,item=>{
                    return item.data.order_number;
                });
                this.$refs.orderSendAll.open();
            },
            //订单批量发货
            batchDeliveryHandle(stop) {
                stop();
                let form = this.$refs.orderSendAllForm.get();
                new Promise(resolve => {
                    if (!form.logistics_company_id) {
                        resolve('请选择物流公司');
                    }

                    if (!form.logistics_number && form.logistics_company_id > 0) {
                        resolve('请填写运单号');
                    }
                    resolve(false);
                }).then(error => {
                    if (error) {
                        this.$message({
                            message: error
                        });
                        return;
                    }

                    this.request({
                        url: '/order/batch/deliver',
                        data: Object.assign(form, {
                            order_number_list:this.deliveryOrderNumbers
                        }),
                        loading: true,
                        success: data => {
                            this.deliveryOrderNumbers = [];
                            this.$refs.orderSendAll.close();
                            //刷新列表
                            setTimeout(() => {
                                this.$refs.search.search();
                            }, 1000);
                            //刷新初始化数据
                            this.initData();
                            this.$confirm({
                                title: '批量发货完成',
                                message: data,  // 提示内容,
                                buttonName: '知道了',  // 确定按钮文字
                                cancelButton: false,  // 是否显示取消按钮
                                resolve: () => {
                                    this.$refs.search.search();
                                },  // 确定按钮回调
                                cancel: () => {},  // 取消按钮回调
                            });
                        }
                    });
                });
            },
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		box-sizing: border-box;
		min-width: 1270px;
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 1140;
			flex-basis: 1140px;
			
			.sku {
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-info {
					flex-grow: 360;
					flex-basis: 360px;
					box-sizing: border-box;
					padding: 10px 0 10px 14px;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 24px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-sku {
					margin-top: 10px;
					font-size: 12px;
				}
				
				&-price,
				&-count {
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 13px;
					text-align: center;
					color: #333;
				}
				&-delivery_count{
					flex-grow: 130;
					flex-basis: 130px;
					font-size: 22px;
					text-align: center;
					color: red;
				}
			}
		}
		
		&-sum,
		&-state,
		&-handle {
			flex-grow: 130;
			flex-basis: 130px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			.c-button {
				width: 6em;
				
				&:nth-child(n+2) {
					margin-top: 8px;
				}
			}
		}
	}
</style>
